var React = require('react');

function ThflagInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0H600V600H0V0Z","fill":"#A51931","key":0}),React.createElement("path",{"d":"M0 100H600V500H0V100Z","fill":"#F4F5F8","key":1}),React.createElement("path",{"d":"M0 200H600V400H0V200Z","fill":"#2D2A4A","key":2})]);
}

ThflagInline.defaultProps = {"width":"600","height":"600","viewBox":"0 0 600 600","fill":"none"};

module.exports = ThflagInline;

ThflagInline.default = ThflagInline;
